import confetti from "canvas-confetti";

const COLORS = ["#D4AF37", "#E5C158", "#FAF9F6", "#997A20"];

export function goldBurst() {
  confetti({ particleCount: 90, spread: 72, startVelocity: 45, origin: { y: 0.6 }, colors: COLORS, disableForReducedMotion: true });
  setTimeout(() => confetti({ particleCount: 45, angle: 60, spread: 55, origin: { x: 0, y: 0.7 }, colors: COLORS, disableForReducedMotion: true }), 140);
  setTimeout(() => confetti({ particleCount: 45, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors: COLORS, disableForReducedMotion: true }), 280);
}
